var _desc, _linearGradient, _linearGradient2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Red X Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A red X icon symbolizing cancellation or removal.")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 50.4129,
    x2: 49.5131,
    y1: 18.8489,
    y2: 95.8626
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9ac97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7125,
    stopColor: "#d6522e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9526,
    stopColor: "#ca330a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 51.4132,
    x2: 48.7189,
    y1: 0.4388,
    y2: 98.3377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb4724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2389,
    stopColor: "#bd3c19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6604,
    stopColor: "#aa2d0a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9526,
    stopColor: "#a32705"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50 63.6c.8 0 1.5.3 2 .9l23 27.4c2.7 3.3 7.7 3.8 10.9 1.1 3.3-2.9 3.8-8 1-11.5l-25.2-30c-.8-1-.8-2.4 0-3.3l25.2-29.9c2.7-3.4 2.3-8.6-1-11.4-3.2-2.7-8.2-2.2-10.9 1l-23 27.3c-1 1.2-3 1.2-4 0l-23-27.3c-2.7-3.4-7.7-3.8-10.9-1.1-3.3 2.9-3.8 8-1 11.5l25.1 29.9c.8 1 .8 2.4 0 3.3l-25.2 30.1c-2.7 3.4-2.3 8.6 1 11.4 3.2 2.7 8.2 2.2 10.9-1l23.1-27.5c.5-.6 1.2-.9 2-.9z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m81 100c-3.9 0-7.5-1.8-10-4.8l-21-25-21.1 25c-4.4 5.4-12.9 6.2-18.2 1.7-5.4-4.7-6.2-13-1.7-18.6l23.9-28.4-23.7-28.3c-4.6-5.6-3.8-14 1.6-18.6 5.3-4.6 13.8-3.8 18.2 1.7l21 24.9 21-25c4.3-5.4 12.9-6.2 18.2-1.6 5.4 4.7 6.2 13 1.7 18.6l-23.8 28.3 23.9 28.4c4.5 5.6 3.8 14-1.6 18.7-2.4 1.9-5.4 3-8.4 3zm-31-36.4c.8 0 1.5.3 2 .9l23 27.4c2.7 3.3 7.7 3.8 10.9 1.1 3.3-2.9 3.8-8 1-11.5l-25.2-30c-.8-1-.8-2.4 0-3.3l25.2-29.9c2.7-3.4 2.3-8.6-1-11.4-3.2-2.7-8.2-2.2-10.9 1l-23 27.3c-1 1.2-3 1.2-4 0l-23-27.3c-2.7-3.4-7.7-3.8-10.9-1.1-3.3 2.9-3.8 8-1 11.5l25.1 29.9c.8 1 .8 2.4 0 3.3l-25.2 30.1c-2.7 3.4-2.3 8.6 1 11.4 3.2 2.7 8.2 2.2 10.9-1l23.1-27.5c.5-.6 1.2-.9 2-.9z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedX);
export default __webpack_public_path__ + "static/media/red-x.ba7e7fef21c081cf05498565e7db3a1c.svg";
export { ForwardRef as ReactComponent };